// extracted by mini-css-extract-plugin
module.exports = {"sortingArrows":"sortingArrows_sortingArrows__LXbB4","active":"sortingArrows_active__mrIT8"};